import { graphql } from "gql.tada";

export const ArticleSideBySideImageFragment = graphql(`
  fragment ArticleSideBySideImageFragment on SideBySideMedia {
    _id
    left {
      url
      contentType
    }
    right {
      url
      contentType
    }
  }
`);
